// extracted by mini-css-extract-plugin
module.exports = {"root":"info-badges_root__GTRUC","infoItem":"info-badges_infoItem__rfSA0","infoItemText":"info-badges_infoItemText__Rtnnc"};